export default __webpack_public_path__ + "static/media/esports-m.6190d680.svg";